"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateTimezoneResponseDto = instanceOfUpdateTimezoneResponseDto;
exports.UpdateTimezoneResponseDtoFromJSON = UpdateTimezoneResponseDtoFromJSON;
exports.UpdateTimezoneResponseDtoFromJSONTyped = UpdateTimezoneResponseDtoFromJSONTyped;
exports.UpdateTimezoneResponseDtoToJSON = UpdateTimezoneResponseDtoToJSON;
exports.UpdateTimezoneResponseDtoToJSONTyped = UpdateTimezoneResponseDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateTimezoneResponseDto interface.
 */
function instanceOfUpdateTimezoneResponseDto(value) {
    if (!('selectedId' in value) || value['selectedId'] === undefined)
        return false;
    if (!('displayName' in value) || value['displayName'] === undefined)
        return false;
    if (!('offsetLabel' in value) || value['offsetLabel'] === undefined)
        return false;
    if (!('autoTimezoneEnabled' in value) || value['autoTimezoneEnabled'] === undefined)
        return false;
    return true;
}
function UpdateTimezoneResponseDtoFromJSON(json) {
    return UpdateTimezoneResponseDtoFromJSONTyped(json, false);
}
function UpdateTimezoneResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'selectedId': json['selectedId'],
        'displayName': json['displayName'],
        'offsetLabel': json['offsetLabel'],
        'autoTimezoneEnabled': json['autoTimezoneEnabled'],
    };
}
function UpdateTimezoneResponseDtoToJSON(json) {
    return UpdateTimezoneResponseDtoToJSONTyped(json, false);
}
function UpdateTimezoneResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'selectedId': value['selectedId'],
        'displayName': value['displayName'],
        'offsetLabel': value['offsetLabel'],
        'autoTimezoneEnabled': value['autoTimezoneEnabled'],
    };
}
